import { useFormContext } from '../context/FormContext';
import { Modal } from './Modal';

export function SubmitErrorModal() {
  const { settings, modalService } = useFormContext();
  const submitResponse = settings.submitResponse;

  if (!submitResponse || submitResponse.success) {
    return null;
  }

  return (
    <Modal modalId="submit-error">
      <div className="stepform-modal">
        <h2
          className="no-line"
          dangerouslySetInnerHTML={{ __html: submitResponse.message || '' }}
        />
        <div>
          <p dangerouslySetInnerHTML={{ __html: submitResponse.message || '' }} />
        </div>
        <p>Please try again.</p>
        <div className="buttons">
          <div>
            <button type="button" className="button" onClick={() => modalService.close('submit-error')}>
              Try payment again
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
